// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3hIGp","inputWrap":"Table_inputWrap__2zF8x","col":"Table_col__3d0WC","bmiTooltip":"Table_bmiTooltip__3x_Cg"};